import React, { useCallback } from "react";
import { useMemo } from "react";
import "./fiche.scss";
import {
  FicheGeneriek,
  FicheGroepsaankoop,
  FicheInspiratie,
  FicheMoveAtWork,
  FichePublicatie,
  FicheTopsportScholen,
  FicheAdres,
  FicheTrainer,
  FicheMentalMatrix,
  FicheBeleefdagen,
  FicheTopsportEvent,
  FicheWebinar,
  FicheInnovatieportfolio,
  FicheWetenschappelijkOnderzoek,
  FicheToolkit,
  FicheGSportkamp,
} from "./Fiches";
import { FicheTopsportAtleet } from "./Fiches/FicheTopsportAtleet/FicheTopsportAtleet";

export const Fiche = (props) => {
  //Returns items as array of <li> elements.
  const processFicheItems = useCallback((itemsData) => {
    let items = [];
    for (let i = 0; i < itemsData.length; i++) {
      const item = itemsData[i];

      //Checks if faulty icon class

      item.icon = item.icon.replace("fw-fa", "fa-fw");

      if (item.icon && !item.icon.includes("fa-fw")) {
        item.icon = "fa-fw " + item.icon;
      }

      if (item.icon && !item.icon.includes("fas")) {
        item.icon = "fas " + item.icon;
      }

      if (item.url) {
        items.push(
          <li className="leaf" key={"bodyItem_" + i}>
            <a href={item.url} target={item.target} onClick={(e) => e.stopPropagation()}>
              {item.icon && <i className={item.icon}></i>}
              <span
                dangerouslySetInnerHTML={{
                  __html: item.text.replaceAll("\\n", "<br/>"),
                }}
              ></span>
            </a>
          </li>
        );
      } else {
        items.push(
          <li className="leaf" key={"bodyItem_" + i}>
            {item.icon && <i className={item.icon}></i>}
            <span
              dangerouslySetInnerHTML={{
                __html: item.text.replaceAll("\\n", "<br/>"),
              }}
            ></span>
          </li>
        );
      }
    }
    return items;
  }, []);

  const fiche = useMemo(() => {
    switch (props.ficheType) {
      case "ficheMoveAtWork":
        return (
          <FicheMoveAtWork
            dictionary={props.dictionary}
            openPopup={props.openPopup}
            data={props.data}
          />
        );
      case "ficheGroepsaankoop":
        return (
          <FicheGroepsaankoop
            dictionary={props.dictionary}
            data={props.data}
            openPopup={props.openPopup}
          />
        );
      case "ficheInspiratie":
        return (
          <FicheInspiratie
            dictionary={props.dictionary}
            data={props.data}
            openPopup={props.openPopup}
            processFicheItems={processFicheItems}
          />
        );
      case "ficheTopsportschool":
        return (
          <FicheTopsportScholen
            dictionary={props.dictionary}
            data={props.data}
            openPopup={props.openPopup}
            processFicheItems={processFicheItems}
          />
        );
      case "fichePublicatie":
        return (
          <FichePublicatie
            dictionary={props.dictionary}
            data={props.data}
            openPopup={props.openPopup}
            processFicheItems={processFicheItems}
          />
        );
      case "ficheGeneriek":
      case "dynamicFiche":
        return (
            <FicheGeneriek
                dictionary={props.dictionary}
                data={props.data}
                openPopup={props.openPopup}
                processFicheItems={processFicheItems}
                isLogoFiche={props.isLogoFiche}
            />
        );
      case "ficheTrainer":
        return (
          <FicheTrainer
            data={props.data}
            processFicheItems={processFicheItems}
          />
        );
      case "ficheAdres":
        return (
          <FicheAdres
            dictionary={props.dictionary}
            data={props.data}
            processFicheItems={processFicheItems}
          />
        );
      case "ficheBeleefdagen":
        return (
          <FicheBeleefdagen
            data={props.data}
            dictionary={props.dictionary}
            processFicheItems={processFicheItems}
          />
        );
      case "ficheMentalMatrix":
        return (
          <FicheMentalMatrix
            dictionary={props.dictionary}
            data={props.data}
            openPopup={props.openPopup}
            processFicheItems={processFicheItems}
          />
        );
      case "ficheTopsportAtleet":
        return (
          <FicheTopsportAtleet
            dictionary={props.dictionary}
            data={props.data}
            openPopup={props.openPopup}
            processFicheItems={processFicheItems}
          />
        );
      case "ficheTopsportevent":
        return (
          <FicheTopsportEvent
            dictionary={props.dictionary}
            data={props.data}
            processFicheItems={processFicheItems}
          />
        );
      case "ficheWebinar":
        return (
          <FicheWebinar
            dictionary={props.dictionary}
            data={props.data}
            openPopup={props.openPopup}
            processFicheItems={processFicheItems}
          />
        );
      case "ficheInnovatieportfolio":
        return (
          <FicheInnovatieportfolio
            dictionary={props.dictionary}
            data={props.data}
            openPopup={props.openPopup}
            processFicheItems={processFicheItems}
          />
        );
      case "ficheWetenschappelijkOnderzoek":
        return (
          <FicheWetenschappelijkOnderzoek
            dictionary={props.dictionary}
            data={props.data}
            openPopup={props.openPopup}
            processFicheItems={processFicheItems}
          />
        );
      case "ficheToolkit":
        return (
          <FicheToolkit
            dictionary={props.dictionary}
            data={props.data}
            openPopup={props.openPopup}
            processFicheItems={processFicheItems}
          />
        );
      case "ficheGSportkamp":
        return (
          <FicheGSportkamp
            dictionary={props.dictionary}
            data={props.data}
            processFicheItems={processFicheItems}
          />
        );
      default:
        return null;
    }
    //Every fiche in a list shares one type, so the data has to be a dependency: without it a filtered list
    //keeps rendering the card that previously sat at the same index.
  }, [props.ficheType, props.data]);

  return <>{fiche}</>;
};
